export default __webpack_public_path__ + "static/media/fangsofset.d985f508.png";